'use client';

import { MarketingExitIntent } from '@/features/marketing/components/exit-intent/MarketingExitIntent';

const EXIT_SESSION_KEY = 'kw_uae_cv_exit_popup_shown';

export function UaeExitIntent() {
  return (
    <MarketingExitIntent
      sessionKey={EXIT_SESSION_KEY}
      title="Applying for Dubai or Gulf jobs?"
      body={
        <>
          Most UAE CVs fail screening because visa status and personal details
          are missing or buried. Check your file against Gulf HR requirements
          with our free <strong>format compliance checker</strong> before you
          apply on Bayt, LinkedIn, or company portals.
        </>
      }
      primaryHref="/resume-format-checker/uae"
      primaryLabel="Check My UAE CV Format (No Login) →"
      secondaryHref="/resume-examples/uae-jobs/"
      secondaryLabel="Browse Dubai & UAE CV Examples"
    />
  );
}
